import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// document.addEventListener("DOMContentLoaded", () => {
const mapId = document.getElementById('mm-editor')!.dataset.mapId ?? 0

ReactDOM.createRoot(document.getElementById('mm-editor')!).render(
    <React.StrictMode>
        <App map={mapId} />
    </React.StrictMode>
)
// });
